import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { StyledDefaultText, StyledLightText, StyledListViewItem, StyledPageTitle, StyledSectionTitle, StyledSmallLightText, StyledSmallText, StyledSubSectionTitle, StyledSubTitle } from './Text.styled';
function createTitle(StyledTitleComponent, defaultHeading) {
  var TitleComponent = function TitleComponent(props) {
    var _ref = props,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? defaultHeading : _ref$heading,
      headerProps = _objectWithoutProperties(_ref, ["heading"]);
    var headingLevel = 'h' + heading;
    var GeneratedTitleComponent = StyledTitleComponent.withComponent(headingLevel);
    return /*#__PURE__*/React.createElement(GeneratedTitleComponent, headerProps, props.children);
  };
  return TitleComponent;
}
export var PageTitle = createTitle(StyledPageTitle, 2);
export var SubTitle = createTitle(StyledSubTitle, 3);
export var SectionTitle = createTitle(StyledSectionTitle, 4);
export var SubSectionTitle = createTitle(StyledSubSectionTitle, 5);
export var Text = StyledDefaultText;
export var LightText = StyledLightText;
export var ListItemText = StyledListViewItem;
export var SmallText = StyledSmallText;
export var SmallLightText = StyledSmallLightText;